import React from "react";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

type IPaginate = {
  current_page: number;
  last_page: number;
  onNext: () => void;
  onBack: () => void;
  disabled?: boolean;
};

const Paginate: React.FC<IPaginate> = ({
  current_page,
  last_page,
  onNext,
  onBack,
  disabled = false,
}) => {
  const onPressNext = () => {
    if (!disabled && current_page < last_page) onNext?.();
  };

  const onPressBack = () => {
    if (!disabled && current_page > 1) onBack?.();
  };

  // Don't render if there's only one page
  if (current_page === 1 && last_page === 1) {
    return null;
  }

  return (
    <div className="flex justify-end py-4 px-2">
      <div className="flex items-center bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        {/* Back button */}
        <button
          onClick={onPressBack}
          disabled={disabled || current_page <= 1}
          className="flex items-center justify-center h-10 w-10 transition-colors duration-200 
                    hover:bg-gray-50 active:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
          aria-label="Previous page"
        >
          <FaChevronLeft
            size={16}
            className={
              disabled || current_page <= 1 ? "text-gray-300" : "text-gray-600"
            }
          />
        </button>

        {/* Page information */}
        <div className="flex items-center px-3 border-x border-gray-100">
          <span className="font-medium text-primary-600">{current_page}</span>
          <span className="mx-2 text-gray-400">/</span>
          <span className="text-gray-600">{last_page}</span>
        </div>

        {/* Next button */}
        <button
          onClick={onPressNext}
          disabled={disabled || current_page >= last_page}
          className="flex items-center justify-center h-10 w-10 transition-colors duration-200 
                    hover:bg-gray-50 active:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
          aria-label="Next page"
        >
          <FaChevronRight
            size={16}
            className={
              disabled || current_page >= last_page
                ? "text-gray-300"
                : "text-gray-600"
            }
          />
        </button>
      </div>
    </div>
  );
};

export default Paginate;
